import React, { useEffect, useState } from 'react';
import './ExtensionApproval.css';
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { useNavigate } from "react-router-dom";
import { Input, Pagination } from "antd";
import axios from "axios";
import { SearchOutlined } from '@ant-design/icons';
import Loader from "../../Components/Loader/Loader";
import { format, parseISO } from "date-fns";

const  ExtensionApproval = () => {
 const Navigate = useNavigate();
    const [ViewTableData, setViewTableData] = useState([])
    const LoginInfo = useState(JSON.parse(sessionStorage.getItem("UserInfo")));
    const [LoaderHiden, setLoaderHiden] = useState(false)
    const [current, setCurrent] = useState(1);
    let setSize = false;

     const DateFormate = (data) => {
            return <td>{format(parseISO(data.dataItem.createdDate), "dd/MM/yyyy")}</td>
        }
    
        const StartTimeFormate = (data) => {
            if (data?.dataItem?.extensionDateTime === null) {
                return <td>{"-"}</td>
            } else {
                return <td>{format(parseISO(data?.dataItem?.extensionDateTime), "hh:mm")}</td>
            }
        }

         useEffect(() => {
                getApprovalPermitTab(JSON.parse(sessionStorage.getItem("UserInfo")))
            }, [])

            const getApprovalPermitTab = (data) => {
                let URL = process.env.REACT_APP_PERMIT + "/Master/GetExtensionApprovel?Empid=" + data.employeeId + "&page=1" + "&pageSize=10"
                axios.get(URL).then((Res) => {
                    setViewTableData(Res.data)
                }).catch((Error) => {
                    console.log(Error, "Error GetNatureofwork")
                })
            }
        
            const ViewRowClick = (data) => {
                if (data.dataItem.permitNumber !== "") {
                    Navigate("/ExtensionApprovePage", { state: data.dataItem })
                }
            }
        
            const ViewRowClickMob = (data) => {
                if (data.permitNumber !== "") {
                    Navigate("/ExtensionApprovePage", { state: data })
                }
            }
        
            const onChangeLogic = (current, size) => {
                setLoaderHiden(true)
                let EmpNo = LoginInfo.employeeId;
                let URL = process.env.REACT_APP_PERMIT + "/Master/GetExtensionApprovel?Empid=" + EmpNo + "&page=" + current + "&pageSize=" + size
                axios.get(URL).then((Res) => {
        
                    setViewTableData(Res.data)
                    setLoaderHiden(false)
                }).catch((Error) => {
                    console.log(Error, "Error GetNatureofwork")
                })
                !setSize && setCurrent(current);
            };
        
            const onSreach = (SearchData) => {
                if (SearchData.length > 3) {
                    let URL = process.env.REACT_APP_PERMIT + "/Master/GetExtensionApprovel?Empid=" + LoginInfo.employeeId + "&page=1" + "&pageSize=10" + "&Search=" + SearchData
                    axios.get(URL).then((Res) => {
                        setViewTableData(Res.data)
                    })
                }
                else {
                    let URL = process.env.REACT_APP_PERMIT + "/Master/GetExtensionApprovel?Empid=" + LoginInfo.employeeId + "&page=1" + "&pageSize=10"
                    axios.get(URL).then((Res) => {
                        setViewTableData(Res.data)
                    }).catch((Error) => {
                        console.log(Error, "Error GetNatureofwork")
                    })
                }
            };

            return (
                <div className="ExtensionApproval">
                    {LoaderHiden && <Loader />}
                    <div className="permitView_web">
                        <div className="Table_Header_Search_Class">
                            <div style={{ flexGrow: '4' }}></div>
                            <h1 style={{ flexGrow: '4' }}>Extension List</h1>
                            <Input style={{ flexGrow: '4' }}
                                className="SearchBox_Class" onChange={(e) => onSreach(e.target.value)} prefix={<SearchOutlined />} />
                        </div>
                    </div>
        
                    <div className="permitView_Mob">
                        <div style={{ flexGrow: '4' }}></div>
                        <h1 className="MobHeader" style={{ flexGrow: '4', }}>Extension List</h1>
                        <div style={{ flexGrow: '4' }}></div>
                        <div className="row" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <Input className="SearchBox_Class_Mob" onChange={(e) => onSreach(e.target.value)} prefix={<SearchOutlined />} />
                        </div>
                    </div>
                    <div className="permitView_web">
                        <Grid className="TableClassMain" data={ViewTableData?.data} onRowClick={ViewRowClick}>
                            <GridColumn field="permitNumber" title="Permit ID" width="210px" />
                            <GridColumn field="permitType" title="Permit Type" width="200px" />
                            <GridColumn field="departmentName" title="Department Name" width="200px" />
                            <GridColumn field="overAllStatus" title="Extension Status" width="200px" />
                            <GridColumn field="createdDate" cell={DateFormate} title="Created Date" width="150px" />
                            <GridColumn field="extensionDateTime" cell={StartTimeFormate} title="Extention Time" width="150px" />
                        </Grid>
                    </div>
                    <div>
                        <div className="permitView_Mob">
                            {ViewTableData?.data?.map((List_item, index) => (
                                <div className="List_Card" onClick={() => ViewRowClickMob(List_item)} key={index}>
                                    <div className="row" style={{ margin: "0% 0% 0% 0%", paddingTop: "1%" }}>
                                        <div className="col-9 gridLeft" style={{ fontWeight: "bold", color: "#354e6c" }} >
                                            <p >{List_item.permitNumber}</p>
                                        </div>
                                        <div className="col-3 gridRight" style={{ fontWeight: "bold" }} >
                                            <p >{format(parseISO(List_item.createdDate), "dd/MM/yyyy")}</p>
                                        </div>
                                    </div>
                                    <div className="row" style={{ margin: "-4% 0% -4% 0%", fontWeight: "bold" }}>
                                        <div className="col-12">
                                            <p className="gridLeft">{List_item.permitType}</p>
                                        </div>
                                    </div>
                                    <div className="row" style={{ margin: "0% 0% 0% 0%" }}>
                                        <div className="col-12">
                                            <p className="gridLeft">{List_item.overAllStatus}</p>
                                        </div>
                                    </div>
                                </div>
                            )
                            )}
                        </div>
                    </div>
                    <div>
                        <Pagination
                            style={{ marginTop: "2%" }}
                            current={current}
                            total={ViewTableData?.count}
                            showTotal={(total) => `Total ${total} items`}
                            onChange={onChangeLogic}
                            showSizeChanger={true} />
                    </div>
                </div>
            )
}
export default ExtensionApproval